"use client";
import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import type { AppLocale } from "@/i18n/config";
export default function ArticlePageLink({
  href,
  locale,
  preserveContext = true,
  className = "",
}: {
  href: string | null;
  locale: AppLocale;
  preserveContext?: boolean;
  className?: string;
}) {
  if (!href) return null;
  const context = preserveContext
    ? locale === "fa"
      ? " (در زبانه جدید)"
      : " (opens in a new tab)"
    : "";
  return (
    <Link
      href={href}
      target={preserveContext ? "_blank" : undefined}
      rel={preserveContext ? "noopener noreferrer" : undefined}
      onClick={(event) => event.stopPropagation()}
      aria-label={context}
      className={`text-pinkCustom border-grayCustom inline-flex p-1 items-center justify-center gap-2 rounded border bg-white text-sm font-semibold hover:bg-pinkCustom hover:text-white duration-200 ${className}`}
    >
      <ArrowUpRight
        aria-hidden="true"
        className="h-4 w-4 shrink-0"
      />
    </Link>
  );
}
